import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';

/**
 * ラベルと値の並び。640px 未満・文字サイズ 131% 以上ではラベルを値の上に積む（05 §3.3b）。
 * 値の氏名・会社名は省略記号で切らずに折り返す。
 */
export interface DescriptionItem {
  label: ReactNode;
  value: ReactNode;
  /** 数字（金額・日付）は等幅 */
  numeric?: boolean;
  /** 2 列分（長い本文） */
  full?: boolean;
}

export function DescriptionList({ items, className, columns = 1 }: { items: DescriptionItem[]; className?: string; columns?: 1 | 2 }) {
  return (
    <dl className={cx('grid gap-x-8 gap-y-3', columns === 2 && 'md:grid-cols-2', className)}>
      {items.map((it, i) => (
        <div
          key={i}
          className={cx(
            'grid gap-1 border-b border-line py-2 last:border-b-0',
            'sm:grid-cols-[minmax(7rem,10rem)_1fr] sm:gap-4 [html[data-font-scale=large]_&]:grid-cols-1',
            it.full && columns === 2 && 'md:col-span-2',
          )}
        >
          <dt className="text-callout text-fg-secondary">{it.label}</dt>
          <dd className={cx('min-w-0 text-body wrap-name', it.numeric && 'tabular')}>{it.value ?? '—'}</dd>
        </div>
      ))}
    </dl>
  );
}
